import { Component } from '@angular/core';

@Component({
  selector: 'app-document-list-skeleton',
  standalone: true,
  templateUrl: './document-list-skeleton.component.html',
  styleUrl: './document-list-skeleton.component.scss'
})
export class DocumentListSkeletonComponent {
  readonly numberOfRows = new Array(5);
  readonly numberOfCols = new Array(6);
}
